export default __webpack_public_path__ + "static/media/Hamamatsu.12a2bfcd.png";